module.exports = {"notification.message":"Wix.com uses cookies to give you the best possible experience.","notification.got.it":"Got It","notification.more.info":"Read More","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_zh.json
// module id = 60
// module chunks = 0